export function AlertBadge({ count, className = "", testid }) {
  if (!count) return null;
  return (
    <span data-testid={testid}
      className={`min-w-[20px] h-5 px-1.5 inline-flex items-center justify-center rounded-full bg-destructive text-white text-[11px] font-semibold leading-none shadow-sm animate-fade-in ${className}`}>
      {count > 99 ? "99+" : count}
    </span>
  );
}
